import translationEN from '@/locales/en/translation.json';
import translationMN from '@/locales/mn/translation.json';
import ENPNG from '@assets/images/languages/en.png'
import MNPNG from '@assets/images/languages/mn.png'

export const LangService = [
    {
        name : 'Монгол',
        lng : 'mn',
        icon : MNPNG,
        translation: translationMN
    },
    {
        name : 'English',
        lng : 'en',
        icon : ENPNG,
        translation: translationEN
    },
]